
import {GetterTree} from 'vuex'
import DataVariable from "../modules/DataVariables/ts/DataVariableInterface";

export const getters: GetterTree<any, any> = {

    dataVariable: (state, getters, rootState, rootGetters) => (uuid: string) => {
        return state.dataVariables.find( (variable: DataVariable) => {
            return variable.uuid===uuid;
        })
    },
};
